import React from "react";
import { Link } from "react-router-dom";
import { FaLock, FaArrowLeft } from "react-icons/fa";

export default function AccessDenied() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        
        {/* Icon */}
        <div className="flex justify-center mb-8">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-red-400 to-pink-400 rounded-full blur-3xl opacity-20"></div>
            <div className="relative bg-white rounded-full p-8 shadow-2xl">
              <FaLock className="text-5xl text-red-500" />
            </div>
          </div>
        </div>

        {/* Error Code */}
        <p className="text-sm font-semibold text-red-500 uppercase tracking-wider mb-2">Error 403</p>
        
        {/* Heading */}
        <h1 className="text-5xl font-bold text-gray-900 mb-6">
          Access <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-red-600">Denied</span>
        </h1>

        {/* Description */}
        <div className="space-y-4 mb-8">
          <p className="text-lg text-gray-600">
            Sorry, you don't have permission to access this page.
          </p>
          <p className="text-gray-500">
            This resource is restricted to authorized users only. If you believe you should have access, please contact your administrator.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mb-6 flex-col">
          <Link 
            to="/" 
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <FaArrowLeft className="text-sm" />
            Back to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 border-2 border-gray-300 hover:border-gray-400 text-gray-700 hover:text-gray-900 font-semibold py-3 px-6 rounded-lg transition-all duration-200"
          >
            Go Back
          </button>
        </div>

        {/* Support Info */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-gray-700">
            <span className="font-semibold">Need help?</span> Contact your gym administrator or support team for assistance.
          </p>
        </div>
      </div>
    </div>
  );
}
